"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssuePane = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const Flag_1 = __importDefault(require("@opsbase/lib-issue/Flag"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const usePerform_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController/usePerform"));
const usePerformQuestion_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestion"));
const usePerformQuestionActions_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestionActions"));
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const IssueIcon_1 = __importDefault(require("@opsbase/web-icons/icons/IssueIcon"));
const SaveIcon_1 = __importDefault(require("@opsbase/web-icons/icons/SaveIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const react_1 = __importStar(require("react"));
require("react-quill/dist/quill.snow.css");
const InnerPane_1 = __importDefault(require("./InnerPane"));
const IssueForm_1 = __importDefault(require("./IssueForm"));
const IssueLinkCard_1 = __importDefault(require("./IssueLinkCard"));
function IssuePane({ onClickClose }) {
    const { settings } = (0, useSelf_1.default)();
    const { mode } = (0, usePerform_1.default)();
    const viewMode = mode === 'view';
    const { answer } = (0, usePerformQuestion_1.default)();
    const { doChangeAnswer } = (0, usePerformQuestionActions_1.default)();
    const hasIssue = !!(answer === null || answer === void 0 ? void 0 : answer.issue);
    const [isDirty, setIsDirty] = (0, react_1.useState)(false);
    const [issue, setIssue] = (0, react_1.useState)((answer === null || answer === void 0 ? void 0 : answer.issue) || {
        title: 'Add a title',
        flag: Flag_1.default.BLACK,
        type: settings.issueTypes[0].key,
    });
    const handleClickSave = (0, react_1.useCallback)(() => {
        setIsDirty(false);
        doChangeAnswer({ issue });
    }, [doChangeAnswer, issue]);
    const handleClickDelete = (0, react_1.useCallback)(() => doChangeAnswer({ issue: null }), [doChangeAnswer]);
    const handleChangeIssue = (0, react_1.useCallback)(v => {
        setIssue(v);
        setIsDirty(true);
    }, []);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(InnerPane_1.default, { label: lib_i18n_1.default.t('issue'), icon: react_1.default.createElement(IssueIcon_1.default, { size: 18 }), onClickClose: onClickClose, showDelete: !viewMode && hasIssue, onClickDelete: handleClickDelete },
        viewMode && (react_1.default.createElement(Pane_1.default, null,
            react_1.default.createElement(IssueLinkCard_1.default, { answer: answer }))),
        !viewMode && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Pane_1.default, null,
                react_1.default.createElement(IssueForm_1.default, { onChange: handleChangeIssue, value: issue })),
            react_1.default.createElement(Pane_1.default, { grow: true }),
            react_1.default.createElement(Pane_1.default, null,
                react_1.default.createElement(Horizontal_1.default, { gutter: true, padding: true, justify: "flex-end" },
                    react_1.default.createElement(Button_1.default, { disabled: !isDirty || viewMode, icon: react_1.default.createElement(SaveIcon_1.default, { size: 24 }), color: lib_palette_1.default.GoodGreen, label: 'Click to save', onClick: handleClickSave }))))))), [
        onClickClose,
        viewMode,
        hasIssue,
        handleClickDelete,
        answer,
        handleChangeIssue,
        issue,
        isDirty,
        handleClickSave,
    ]);
}
exports.IssuePane = IssuePane;
exports.default = IssuePane;
